import { render, staticRenderFns } from "./ProDetail.vue?vue&type=template&id=327048e9&scoped=true&"
import script from "./ProDetail.vue?vue&type=script&lang=js&"
export * from "./ProDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProDetail.vue?vue&type=style&index=0&id=327048e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327048e9",
  null
  
)

export default component.exports